import {api} from "./api";
import {MODERATOR_NEWS} from "../mock/URLs";
import {GetNewsResponse, INewsItemById} from "../types/news";

type NewsPostValues = {
  params: {
    page_size: number
    page: number
    search?: string
  }
}

export const getNews = async ({params}: NewsPostValues) => {
  try {
    const {data} = await api.get<GetNewsResponse>(MODERATOR_NEWS, {
      params
    })
    return data
  } catch (e) {
    throw e
  }
}

export const createNews = async (values: FormData) => {
  try {
    const {data} = await api.post(MODERATOR_NEWS, values)
    return data
  } catch (e) {
    throw e
  }
}

export const updateNews = async (id: number | string, values: FormData) => {
  try {
    const {data} = await api.patch(`${MODERATOR_NEWS}${id}/`, values)
    return data
  } catch (e) {
    throw e
  }
}

export const getNewsById = async (id: number | string): Promise<INewsItemById> => {
  try {
    const {data} = await api.get<{ data: INewsItemById }>(`${MODERATOR_NEWS}${id}/`);
    return data.data
  } catch (e) {
    throw e
  }
}